import React,{useState,useEffect} from 'react';
import {Button,Card, CardActions} from 'react-md';
import { BeatLoader } from 'react-spinners';
import { NotificationManager,NotificationContainer} from 'react-notifications';

const styles = {
    container:{
        display:'flex',
        flexWrap:'wrap',
        alignItems: 'center',
        justifyContent:'center',
        backgroundColor:'inherit',
        height:window.innerHeight
    },
    buttonStyle:{
        marigin:'auto',
    }
}



const ActivatePage = ({history,apiService}) => {
    const {location} = history;
    const [loading,setLoading] = useState(true);
    const pathname = location.pathname;
    const key = pathname.replace('/activate/','');
    const [userName,setUserName] = useState('');
    useEffect(() => {
        if(key && key.length > 0)
            getUserName();
    }, [key])

    const getUserName = () => {
        let responsePromise = apiService({
            method: 'get',
            url: '/getUserName/'+key,
            skipErrorHandle:true
        });
        responsePromise.then(res => {
            if(res.data){
                if(res.data && res.data.status === 1 && res.data.message){
                    console.debug(res.data.message, 'ERROR', 10000);
                   return;
                }
                //Redirect to Login
                setUserName(res.data.data)
            }else{
                console.debug("Server didn't respond", 'ERROR', 10000);
                return;
            }
        }).catch(error => {
            console.debug('Unable to fetch User name',error);
        }).finally(()=>{
            setLoading(false);
        });
    }

    const activateUser = () => {
        setLoading(true);
            let responsePromise = apiService({method: 'get',
            url: pathname,
            skipErrorHandle:true});
              responsePromise.then(res => {
                if(res.data){
                    if(res.data && res.data.status === 1 && res.data.message){
                        NotificationManager.error(res.data.message, 'ERROR', 10000);
                        return;
                    }
                    //Redirect to Login
                    history.push('/');
                }
                else{
                    NotificationManager.error("Server didn't respond", 'ERROR', 10000);
                    return;
                }

              }).catch(error => {
                NotificationManager.error("Unable to activate, please contact your course instructor", 'ERROR', 10000);
              }).finally(()=>{
                setLoading(false);
              });
    }
    
   

    if (key && key.length > 0 && pathname.includes('/activate/')){
        return <div style={styles.container}>
        {
            loading?
            <BeatLoader color='#bb0000' loading={true} size={10} />:
            <Card style={{padding:'20px'}}>
                <center>
                    <h2  style={{margin:'0px'}}>Welcome {userName} !</h2><br/>
                </center>
                <h4>Please click on the button below to activate your account.</h4>
            <CardActions style={{justifyContent:'center'}}>
                <Button style={styles.buttonStyle} primary raised onClick={activateUser}>Activate</Button>
            </CardActions>
            </Card>
        }
        <NotificationContainer/>
        </div>
    }else{
        return <p>invalid or empty key</p>
    }
    
   
}

export default ActivatePage;